import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { generateRotationsplanPdf } from '@/domain/mitarbeiter/features/rotationsplan/features/ExportRotationsplan/generateRotationsplanPdf';
import { toast } from '@/hooks/use-toast';
import { DropdownMenuItem } from '@e2n/ui';
import * as Sentry from '@sentry/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ExportRotationsplanDesktop({
  rotationsplan,
  onClose,
}: {
  rotationsplan: Rotationsplan;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);

  async function handleExport() {
    setIsExporting(true);
    try {
      await generateRotationsplanPdf(rotationsplan);
    } catch (error) {
      toast({ title: t('general.genericErrorMessage') });
      Sentry.captureException(error);
    } finally {
      setIsExporting(false);
      onClose();
    }
  }

  return (
    <DropdownMenuItem
      disabled={isExporting}
      onClick={(e) => {
        e.preventDefault();
        void handleExport();
      }}>
      {t('domain.mitarbeiter.rotationsplan.rotationsplaene.export.label')}
    </DropdownMenuItem>
  );
}
